export default __webpack_public_path__ + "static/media/que-step4.7957de9d.gif";